import { render, staticRenderFns } from "./refereeDocumentList.vue?vue&type=template&id=78ae39f6&scoped=true"
import script from "./refereeDocumentList.vue?vue&type=script&lang=js"
export * from "./refereeDocumentList.vue?vue&type=script&lang=js"
import style0 from "./refereeDocumentList.vue?vue&type=style&index=0&id=78ae39f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ae39f6",
  null
  
)

export default component.exports